import { Component, OnInit, Output, EventEmitter, Input, SimpleChange, SimpleChanges, OnChanges } from '@angular/core';
import { FileService } from 'projects/services/src/app/API/file.service';

@Component({
	selector: 'app-upload-document',
	templateUrl: './upload-document.component.html',
	styleUrls: ['./upload-document.component.css']
})
export class UploadDocumentComponent implements OnInit, OnChanges {
	@Input() disabled = false;
	@Input() data: { type?: any, size?: number, label?: string, placeholder?: string, class?: string, uploadButton?: string };
	file: File;
	fileUploadErrorMessage = 'No File Uploaded Yet';
	isValidFile: Boolean = false;

	@Output() uploadResult = new EventEmitter<any>();
	@Output() fileUploadCancel = new EventEmitter<any>();
	constructor(
		private _fileUploadService: FileService
	) { }

	ngOnInit() {
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.data.currentValue) {
			console.log('changes disabled', changes.disabled);
		}
	}

	onFileChange(event) {
		const fileList = event.target.files;
		this.file = fileList[0];
		console.log(fileList[0]);
		if (fileList.length > 0) {
			const validTypes = [
				'application/docx',
				// 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
				'application/msword',
				'application/pdf',
				// 'application/xls',
				'application/xls',
				// 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				'application/zip'
			];
			if (fileList) {
				const fileType = fileList[0].type;
				const fileSize = fileList[0].size;
				const convertedFileSize = this.formatFileSize(this.data.size);
				if (validTypes.indexOf(fileType) >= 0) {          // }
					// if (fileList[0].type === 'application/msword' || fileList[0].type === 'application/pdf' ||) {
					if (this.data && (fileSize > this.data.size)) {
						this.fileUploadErrorMessage = `File size should not exceed ${convertedFileSize}`;
					} else {
						this.fileUploadErrorMessage = 'Click Submit to upload your file';
						this.isValidFile = true;
					}
				} else {
					this.fileUploadErrorMessage = `Please upload docx/pdf/xls,xlsx,zip files`;
					// this.uploadResult.emit({ file: this.file, response: 'Failed' });
				}
			}
		} else {
			this.fileUploadCancel.emit();
			this.fileUploadErrorMessage = '';
		}
	}

	uploadFile() {
		this._fileUploadService.uploadFile(this.file.name, this.file).subscribe(res => {
			this.fileUploadErrorMessage = '';
			this.uploadResult.emit({ file: this.file, response: 'Success', header: res });
		}, error => {
			this.fileUploadErrorMessage = 'Something went wrong please try again';
			this.uploadResult.emit({ file: this.file, response: 'Failed' });
		});
	}

	formatFileSize(bytes, decimalPoint?) {
		if (bytes === 0) { return '0 Bytes'; }
		const k = 1000,
			dm = decimalPoint || 2,
			sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
			i = Math.floor(Math.log(bytes) / Math.log(k));
		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}

}
